import React, { useEffect, useState, useRef } from "react";
import { currentDateFormat } from "../utils";
import {
  TRIP_LIST,
  GET_DRIVER_LIST,
  GET_ALL_PAYER,
  GET_SCHEPASSENGER_LIST,
} from "../constant";
// import TripTable from '../components/tables/TripTable';
import TripTable from "../components/tables/TripLatestTable";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { setLoading } from "../redux/loaderAction";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import SearchComponent from "../components/SearchComponent";
//import Swal from '../../node_modules/sweetalert2/dist/sweetalert2';
import Swal from "../messageBox/customSweetAlert";
import moment from "moment";
import { exportToExcel, exportFullTableToPDF } from "../utils";

function TripList() {
  const tableRef = useRef();
  const [currentDate, setCurrentDate] = useState(new Date());
  const [tripList, setTripList] = useState([]);
  const dispatch = useDispatch();
  const [reload, setReload] = useState(false);
  const [payerList, setPayerList] = useState([]);
  const [driverList, setDriverList] = useState([]);
  const [payer, setPayer] = useState("0");
  const [fromDate, setFromDate] = useState(new Date());
  const [toDate, setToDate] = useState(new Date());
  const [selectedDriver, setSelectedDriver] = useState(null);
  const [selectedPassenger, setSelectedPassenger] = useState(null);
  const [passengerList, setPassengerList] = useState([]);
  const [filteredTripList, setFilteredTripList] = useState([]);
  const [tripStatus, setTripStatus] = useState("3");
  const [errors, setErrors] = useState({});
  const [showAllRowsForExport, setShowAllRowsForExport] = useState(false);
  const [isSearchLoading, setIsSearchLoading] = useState(false);

  const fetchTrips = async () => {
    const payload = {
      passenger_id: selectedPassenger?.passenger_id || "", // optional chaining
      driver_id: selectedDriver?.driver_id || "",
      payer_id: payer || "0", // if "All" is selected, keep as 0
      trip_status: tripStatus || "3", // 3 = All
      from_date: fromDate ? moment(fromDate).format("YYYY-MM-DD") : "",
      to_date: toDate ? moment(toDate).format("YYYY-MM-DD") : "",
    };
    dispatch(setLoading(true));
    try {
      const response = await axios.post(TRIP_LIST, payload);

      if (response?.status === 200) {
        dispatch(setLoading(false));
        //console.log(response.data);
        setTripList(response?.data);
        setFilteredTripList(response?.data);
        //filterByCurrentDate(response?.data)
      }
    } catch (error) {
      console.error("Error fetching schedules:", error);
      dispatch(setLoading(false));
    }
  };

  const handleDeleteSuccess = (deletedTripId) => {
    //console.log("deletedTripId=filteredTripList",filteredTripList);
    setReload(!reload);

    Swal.fire({
      title: "Success!",
      text: "Trip Deleted Successfully",
      icon: "success",
      confirmButtonText: "OK",
    });
    setTripList((prev) =>
      prev.filter((item) => item.trip?.trip_id !== deletedTripId)
    );
    setFilteredTripList((prev) =>
      prev.filter((item) => item.trip?.trip_id !== deletedTripId)
    );
  };

  useEffect(() => {
    fetchTrips();
    const loadUser = async () => {
      const response_2 = await axios.get(GET_DRIVER_LIST);
      const response_3 = await axios.get(GET_ALL_PAYER);
      const response_4 = await axios.get(GET_SCHEPASSENGER_LIST);
      //console.log(response_3.data);

      setDriverList(response_2.data);
      setPayerList(response_3.data);
      setPassengerList(response_4.data);
    };
    loadUser();
  }, [reload, dispatch]);

  const handlePayerChange = (e) => {
    setPayer(e.target.value);
  };

  const handleStatusChange = (e) => {
    setTripStatus(e.target.value);
  };
  const setToMidnight = (date) => {
    const newDate = new Date(date);
    newDate.setHours(0, 0, 0, 0);
    return newDate;
  };

  const filterByCurrentDate = (data) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Set today's date to midnight
    const from = setToMidnight(fromDate);
    const to = setToMidnight(toDate);

    if (fromDate && toDate) {
      const filteredData = data.filter((item) => {
        //const tripDate = new Date(item?.trip?.tripDate);
        const tripDate = setToMidnight(item?.trip?.tripDate);
        //console.log("Trip Date:", tripDate, "From:", from, "To:", to);
        return (
          (!fromDate || tripDate >= setToMidnight(fromDate)) &&
          (!toDate || tripDate <= setToMidnight(toDate))
        );
      });
      setFilteredTripList(filteredData);
    } else {
      const filteredData = data.filter((item) => {
        const tripDate = new Date(item?.trip?.tripDate);
        return (
          tripDate.getFullYear() === today.getFullYear() &&
          tripDate.getMonth() === today.getMonth() &&
          tripDate.getDate() === today.getDate() &&
          item.trip?.is_completed === 1
        );
      });
      setFilteredTripList(filteredData);
    }

    //setFilteredScheduleList(filteredData);
  };

  const handleSearch = async () => {
    if (errors.from_date || errors.to_date) {
      Swal.fire(
        "Error",
        "Please correct the date errors before searching",
        "error"
      );
      return false;
    }
    const payload = {
      passenger_id: selectedPassenger?.value?.user_id || "", // optional chaining
      passenger_name: selectedPassenger?.value?.full_name || "", // optional chaining
      driver_id: selectedDriver?.value?.user_id || "",
      driver_name: selectedDriver?.value?.full_name || "",
      payer_id: payer || "0", // if "All" is selected, keep as 0
      trip_status: tripStatus || "3", // 3 = All
      from_date: fromDate ? moment(fromDate).format("YYYY-MM-DD") : "",
      to_date: toDate ? moment(toDate).format("YYYY-MM-DD") : "",
    };
    setIsSearchLoading(true);
    dispatch(setLoading(true));
    try {
      const response = await axios.post(TRIP_LIST, payload);
      if (response?.status === 200) {
        setTripList(response?.data);
        //setFilteredScheduleList(response.data);
        //filterByCurrentDate(response?.data);
        setFilteredTripList(response?.data);
      }
    } catch (error) {
      console.error("Error fetching schedules:", error);
    } finally {
      dispatch(setLoading(false));
      setIsSearchLoading(false);
    }
  };

  const driverListWithFullName = driverList.map((driver) => {
    const fullName = `${driver.first_name} ${driver.middle_name || ""} ${
      driver.last_name
    }`
      .replace(/\s+/g, " ") // Remove extra spaces
      .trim()
      .toLowerCase();

    return {
      ...driver,
      full_name: fullName,
    };
  });
  const passengerListWithFullName = passengerList.map((passenger) => {
    const fullName = `${passenger.first_name} ${passenger.middle_name || ""} ${
      passenger.last_name
    } ${passenger.passenger.pass_pmi_no || ""}`
      .replace(/\s+/g, " ") // Remove extra spaces
      .trim()
      .toLowerCase();

    return {
      ...passenger,
      full_name: fullName,
    };
  });

  const handleExcelClick = () => {
    // console.log("document.getElementById('trip-table')",document.getElementById('trip-table'));
    exportToExcel(document.getElementById("trip-table"), "TripList");
  };
  // Prepare readable filter data for header/PDF
  const filterPayerName =
    payer === "0"
      ? "All"
      : payerList.find((p) => String(p.id) === String(payer))?.payer_name || "";

  const filterDriverName = selectedDriver?.label
    ? selectedDriver.label
    : selectedDriver?.value?.first_name
    ? selectedDriver.value?.first_name +
      " " +
      (selectedDriver.value?.middle_name || "") +
      (selectedDriver.value?.last_name || "")
    : "All";

  const filterPassengerName = selectedPassenger?.value?.first_name
    ? selectedPassenger.value.first_name +
      " " +
      (selectedPassenger.value.middle_name || "") +
      " " +
      (selectedPassenger.value.last_name || "")
    : "All";

  const filterTripStatusStr =
    tripStatus === "3"
      ? "All"
      : tripStatus === "1"
      ? "Completed"
      : tripStatus === "0"
      ? "Pending"
      : "";

  const filterFromDateStr = fromDate
    ? moment(fromDate).format("MM/DD/YYYY")
    : "";
  const filterToDateStr = toDate ? moment(toDate).format("MM/DD/YYYY") : "";
  return (
    <>
      <section style={{ borderBottom: "solid 1px #eee", marginTop: "0px" }}>
        <div className="d-flex justify-content-between form-container">
          <div>
            <h2 className="fs-5 font-weight-600">Trip List </h2>
          </div>
          <div>
            <span>{currentDateFormat(currentDate)}</span>
          </div>
        </div>
      </section>
      <section className="filter-section">
        <div
          className="d-flex justify-content-between filter-container"
          style={{ background: "rgb(205 228 218 / 29%)" }}
        >
          <div className="schedule-filter">
            <div className="me-2">
              {/* <label style={{display:"block"}}>Passenger</label> */}
              <SearchComponent
                data={passengerListWithFullName}
                searchFields={["full_name"]}
                placeholder="Search Passenger"
                label="Passenger"
                onSelect={(selectedPassenger) => {
                  setSelectedPassenger(selectedPassenger);
                }}
              />
            </div>
            <div className="me-2">
              <SearchComponent
                data={driverListWithFullName} // Pass the driver data
                searchFields={["full_name"]} // Fields to search
                placeholder="Search Driver"
                label="Driver"
                onSelect={(selectedDriver) => {
                  setSelectedDriver(selectedDriver);
                }}
                onChange={(selectedDriver) => {
                  setSelectedDriver(selectedDriver);
                }}
              />
            </div>

            <div className="me-2">
              <label style={{ display: "block" }}>Payer</label>
              <select
                className="form-select"
                name="payer"
                value={payer}
                onChange={handlePayerChange}
              >
                <option value="0">All</option>
                {payerList.map((payer, index) => (
                  <option key={index} value={payer.id}>
                    {payer.payer_name}
                  </option>
                ))}
              </select>
            </div>
            <div className="me-2">
              <label style={{ display: "block" }}>Status</label>
              <select
                className="form-select"
                name="status"
                value={tripStatus}
                onChange={handleStatusChange}
              >
                <option value="3">All</option>
                <option value="1">Completed</option>
                <option value="0">Pending</option>
              </select>
            </div>
            <div>
              <div className="me-2 date-container">
                <label style={{ display: "block" }}>From</label>
                <DatePicker
                  selected={fromDate}
                  onChange={(date) => {
                    const today = new Date();
                    today.setHours(23, 59, 59, 999); // Set to end of today to allow today's date
                    
                    if (date > today) {
                      setErrors({
                        from_date: "Cannot select future date",
                      });
                      return;
                    }
                    if (toDate && date > toDate) {
                      setErrors({
                        from_date: "From date greater than To date",
                      });
                    } else {
                      setErrors({});
                    }
                    setFromDate(date);
                  }}
                  maxDate={new Date()}
                  dateFormat="MM/dd/yyyy"
                  autoComplete="off"
                  className="datepicker form-control hasDatepicker"
                  id="from_date"
                  name="from_date"
                ></DatePicker>
              </div>
              <div className="error-message" style={{ maxWidth: "100%" }}>
                {errors.from_date && (
                  <span
                    className="errors"
                    style={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      display: "inline-block",
                    }}
                  >
                    {errors.from_date}
                  </span>
                )}
              </div>
            </div>
            <div>
              <div className="me-2 date-container">
                <label style={{ display: "block" }}>To</label>
                <DatePicker
                  selected={toDate}
                  onChange={(date) => {
                    const today = new Date();
                    today.setHours(23, 59, 59, 999); // Set to end of today to allow today's date
                    
                    if (date > today) {
                      setErrors({ to_date: "Cannot select future date" });
                      return;
                    }
                    if (fromDate && date < fromDate) {
                      setErrors({ to_date: "To date less than From date" });
                    } else {
                      setErrors({ from_date: "" });
                    }
                    setToDate(date);
                  }}
                  maxDate={new Date()}
                  dateFormat="MM/dd/yyyy"
                  autoComplete="off"
                  className="datepicker form-control hasDatepicker"
                  id="to_date"
                  name="to_date"
                ></DatePicker>
              </div>
              <div className="error-message" style={{ maxWidth: "100%" }}>
                {errors.to_date && (
                  <span
                    className="errors"
                    style={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      display: "inline-block",
                    }}
                  >
                    {errors.to_date}
                  </span>
                )}
              </div>
            </div>
            <div>
              <div>
              <button
                  className="btn btn-primary rounded-1"
                  type="button"
                  style={{
                    background: "#31876f",
                    border: "unset",
                    height: "38px",
                    color: "#fff",
                    padding: "7px",
                  }}
                  onClick={handleSearch}
                  disabled={isSearchLoading}
                >
                  {isSearchLoading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Searching...
                    </>
                  ) : (
                    "Search"
                  )}
                </button>
              </div>
            </div>
            {/* <button onClick={handleExcelClick}>click</button> */}
            <span>
              <i
                className="pi pi-file-excel"
                title="Export to Excel"
                onClick={handleExcelClick}
                style={{ fontSize: "24px", color: "green", cursor: "pointer" }}
              ></i>
              <i
                className="pi pi-file-pdf"
                title="Download PDF"
                style={{
                  fontSize: "24px",
                  color: "red",
                  cursor: "pointer",
                  marginLeft: "10px",
                }}
                onClick={() => {
                  // Avoid table change: temporarily set showAllRowsForExport for export, then restore
                  setShowAllRowsForExport(true);
                  setTimeout(() => {
                    exportFullTableToPDF(
                      tableRef,
                      setShowAllRowsForExport,
                      "trip_table.pdf"
                    );
                    setShowAllRowsForExport(false);
                  }, 100);
                }}
              ></i>
            </span>
          </div>
        </div>
      </section>
      <section>
        <div className="table-responsive">
          <TripTable
            ref={tableRef}
            tableData={filteredTripList}
            setTableData={setFilteredTripList}
            onDeleteSuccess={handleDeleteSuccess}
            showAllRowsForExport={showAllRowsForExport}
            filterPayer={filterPayerName}
            filterDriver={filterDriverName}
            filterPassenger={filterPassengerName}
            filterTripStatusStr={filterTripStatusStr}
            filterFromDate={filterFromDateStr}
            filterToDate={filterToDateStr}
          />
        </div>
      </section>
    </>
  );
}

export default TripList;
